import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const ContentLoader = ({ text, isFull, w, h }) => (
  <S.Container isFull={isFull} width={w} height={h}>
    <div>
      <div className="loader" />
      {text && <p>{text}</p>}
    </div>
  </S.Container>
);

ContentLoader.defaultProps = {
  text: 'Loading...',
  isFull: false,
  w: 80,
  h: 80,
};

ContentLoader.propTypes = {
  text: PropTypes.string,
  isFull: PropTypes.bool,
  w: PropTypes.number,
  h: PropTypes.number,
};

export default ContentLoader;
